import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Utils } from 'versafleet-core';

const { RequestHelper: { request } } = Utils;

export function useVerifyContactNumber() {
  const queryClient = useQueryClient();
  const { detail } = useParams();

  const url = `/tasks/${detail}/verify_contact_number`;

  const {
    isLoading: isLoadingVerifyContactNumber,
    error: errorVerifyContactNumber,
    mutateAsync: verifyContactNumber,
  } = useMutation({
    mutationFn: data => request(url, {
      method: 'POST',
    }, { digit: data }),
    onSuccess: (data) => {
      queryClient.setQueryData(['verifyContactNumber'], data.verified);
    },
    onError: () => {
      queryClient.setQueryData(['verifyContactNumber'], false);
    },
  });

  const { data: isVerified } = useQuery({
    queryKey: ['verifyContactNumber'],
    initialData: false,
  });

  return {
    isLoadingVerifyContactNumber,
    errorVerifyContactNumber,
    verifyContactNumber,
    isVerified,
  };
}

export function useGetTimeWindowsAvailability() {
  const queryClient = useQueryClient();
  const { detail } = useParams();

  const url = `/tasks/${detail}/time_windows_availability`;

  const {
    isLoading: isLoadingTimeWindowsAvailability,
    mutateAsync: getTimeWindowsAvailability,
    error: errorTimeWindowsAvailability,
  } = useMutation({
    mutationFn: data => request(url, {
      method: 'POST',
    }, { from_date: data }),
    onSuccess: (data) => {
      queryClient.setQueryData(['timeWindowsAvailability'], data.time_windows_availability);
    },
    onError: () => {
      queryClient.setQueryData(['timeWindowsAvailability'], {});
    },
  });

  const { data: timeWindowsAvailability } = useQuery({
    queryKey: ['timeWindowsAvailability'],
    initialData: {},
  });

  return {
    isLoadingTimeWindowsAvailability,
    errorTimeWindowsAvailability,
    getTimeWindowsAvailability,
    timeWindowsAvailability,
  };
}

export function useRescheduleTask() {
  const { detail } = useParams();

  const url = `/tasks/${detail}/reschedule_task`;

  const {
    isLoading: isLoadingRescheduleTask,
    mutateAsync: rescheduleTask,
    error: errorRescheduleTask,
    reset: resetRescheduleTask,
  } = useMutation({
    mutationFn: data => request(url, {
      method: 'POST',
    }, {
      ...data,
    }),
  });

  return {
    isLoadingRescheduleTask,
    rescheduleTask,
    errorRescheduleTask,
    resetRescheduleTask,
  };
}
